'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { forwardRef, useEffect, useState } from 'react'
import { useUnity } from '@/hooks/use-unity'

const WWW_REGEX = /^https?:\/\/www\./

interface HomeLinkProps extends React.ComponentPropsWithoutRef<typeof Link> {
  href: string
  children: React.ReactNode
  className?: string
}

function resolveHomeHref(
  url: string,
  unityReference: string | undefined,
  pathname: string | null
): string {
  let processedUrl = url.replace(WWW_REGEX, match =>
    match.replace('www.', '')
  )

  if (unityReference === 'U5071E012' && pathname === '/') {
    if (processedUrl.startsWith('/')) {
      processedUrl = `https://soeducador.com.br${processedUrl}`
    }
  }

  return processedUrl
}

export const HomeLink = forwardRef<HTMLAnchorElement, HomeLinkProps>(
  function HomeLink({ href, children, className, ...props }, ref) {
    const pathname = usePathname()
    const { unity } = useUnity()
    const [resolvedHref, setResolvedHref] = useState(href)

    useEffect(() => {
      setResolvedHref(resolveHomeHref(href, unity?.reference ?? undefined, pathname))
    }, [href, unity?.reference, pathname])

    return (
      <Link className={className} href={resolvedHref} ref={ref} {...props}>
        {children}
      </Link>
    )
  }
)
